import React from 'react';
import { Typography } from '@mui/material';
import { useThemeMode } from '../theme/ThemeModeContext';
import { accent, darkTokens, lightTokens } from '../theme/tokens';

const AuthCustomerHeading = ({
  customerName,
  overline = 'Velkommen',
  showOverline = true
}) => {
  const { mode } = useThemeMode();
  const tokens = mode === 'dark' ? darkTokens : lightTokens;

  return (
    <>
      {showOverline && (
        <Typography
          variant="overline"
          sx={{
            display: 'block',
            mb: 1.5,
            fontWeight: 700,
            letterSpacing: '0.12em',
            color: tokens.ink70
          }}
        >
          {overline}
        </Typography>
      )}

      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: 700,
          letterSpacing: '-0.02em',
          color: tokens.fg,
          mb: 0.5
        }}
      >
        Du logger på i
      </Typography>

      <Typography
        variant="h3"
        component="p"
        sx={{
          fontWeight: 800,
          letterSpacing: '-0.03em',
          color: accent.main,
          mb: 4
        }}
      >
        {customerName}
      </Typography>
    </>
  );
};

export default AuthCustomerHeading;
